import {
  ApplicationConfig,
  importProvidersFrom,
  inject,
  provideAppInitializer,
} from '@angular/core';
import { provideRouter, withPreloading, withRouterConfig } from '@angular/router';
import { provideAnimations } from '@angular/platform-browser/animations';
import { provideHttpClient, withFetch, withInterceptors } from '@angular/common/http';
import { provideServiceWorker } from '@angular/service-worker';
import { Title } from '@angular/platform-browser';
import { TranslateLoader, TranslateModule } from '@ngx-translate/core';
import { TRANSLATE_HTTP_LOADER_CONFIG, TranslateHttpLoader } from '@ngx-translate/http-loader';
import { FaIconLibrary } from '@fortawesome/angular-fontawesome';
import { faEnvelope, faPhone } from '@fortawesome/free-solid-svg-icons';

import { routes } from './app.routes';
import { turnstileInterceptor } from './core/interceptors/turnstile.interceptor';
import { tokenInterceptor } from './core/interceptors/token.interceptor';
import { CustomPreloadingStrategyService } from './shared/services';
import { WINDOW, DOCUMENT_TOKEN, NAVIGATOR } from './core/tokens';
import { fabIcons } from './shared/moduleData/fabIcons';
import { environment } from '../environments/environment';

export const appConfig: ApplicationConfig = {
  providers: [
    Title,
    provideRouter(
      routes,
      withPreloading(CustomPreloadingStrategyService),
      withRouterConfig({ onSameUrlNavigation: 'reload' }),
    ),
    provideAnimations(),
    provideHttpClient(withInterceptors([turnstileInterceptor, tokenInterceptor]), withFetch()),
    provideServiceWorker('ngsw-worker.js', { enabled: environment.production }),
    importProvidersFrom(
      TranslateModule.forRoot({
        loader: {
          provide: TranslateLoader,
          useClass: TranslateHttpLoader,
        },
        extend: true,
      }),
    ),
    {
      provide: TRANSLATE_HTTP_LOADER_CONFIG,
      useValue: { prefix: './assets/i18n/', suffix: '.json' },
    },
    { provide: WINDOW, useValue: window },
    { provide: DOCUMENT_TOKEN, useValue: document },
    { provide: NAVIGATOR, useValue: navigator },
    provideAppInitializer(() => {
      const library = inject(FaIconLibrary);
      library.addIcons(...fabIcons, faEnvelope, faPhone);
    }),
  ],
};
